import React, { FC } from "react";
import { InstantValuationToolPages } from "./components/InstantValuationToolPages";
import { observer } from "mobx-react";
import { UserAccountStore } from "store/UserAccounts/UserAccount/UserAccount.store";
import { Route, Switch } from "react-router-dom";
import {
  TOOLS_IVT_PAGE_DETAILS_ROUTE,
  TOOLS_IVT_ROUTE,
} from "constants/routes";
import { InstantValuationToolPageSettings } from "./components/InstantValuationToolPageSettings/InstantValuationToolPageSettings";

interface IProps {
  accountStore: UserAccountStore;
}

export const InstantValuationTool: FC<IProps> = observer(({ accountStore }) => {
  return (
    <Switch>
      <Route path={TOOLS_IVT_ROUTE} exact>
        <InstantValuationToolPages accountStore={accountStore} />
      </Route>
      <Route path={TOOLS_IVT_PAGE_DETAILS_ROUTE} exact>
        <InstantValuationToolPageSettings accountStore={accountStore} />
      </Route>
    </Switch>
  );
});
